module.exports = __webpack_public_path__ + "static/Q3-2021_announcement_financial_results_investor_call-7f90906dc9a3845301d5bb012817a3dd.pdf";